import { Component, EventEmitter, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { AnyCatcher } from 'rxjs/internal/AnyCatcher';
import { SubscriptionService } from 'src/app/services/subscription.service';


@Component({
  selector: 'app-reason-for-churn',
  templateUrl: './reason-for-churn.component.html',
  styleUrls: ['./reason-for-churn.component.scss']
})
export class ReasonForChurnComponent implements OnInit {
  @Input() partnerId!: any
  @Input() subId!: any
  @Input() isExpired! :any
  event: EventEmitter<any> = new EventEmitter();
  categoryList = [
    'Shifted Offline',
    'Better price from competitor',
    'Switched to another software',
    'Downtime issue',
    'Service issue',
    'Shifted to partner portal',
    'Multiple subscription',
    'Shifted to VPS from CoCloud',
    'Others'
  ];
   trialExpired = [
    'Budget issue',
    'Got a better price from a competitor',
    'Service issue',
    'Did not like the solution',
    'Internet issue at customer end',
    'Others'
  ]
  remarkForm = new FormGroup({
    category: new FormControl('', Validators.required),
    remark: new FormControl('', Validators.required)
  })
  constructor(
    public bsModalRef: BsModalRef,
    private toastr: ToastrService,
    private subscriptionService: SubscriptionService

  ) { }

  ngOnInit(): void {
  }

  onSubmit() {
    if (this.remarkForm.invalid) {
      this.remarkForm.markAllAsTouched()
      return
    }

    const remarkPayload = {
      remark: this.remarkForm.value.remark,
      partnerId: this.partnerId,
      category: this.remarkForm.value.category,
      subId: this.subId
    }
    this.subscriptionService.reasonForChurn(remarkPayload).subscribe((res: any) => {
      if (res.success) {
        this.toastr.success(res.message)
        this.bsModalRef.hide()
        this.event.emit('ok');
      }

    }, (err: any) => {
      this.toastr.error(err.error.message)

    })
  }
}
